<template>
  <Modal closable>
    <template v-slot:header>
      <h2 v-if="!sent">Feedback</h2>
      <h2 v-else>Tusind tak!</h2>
    </template>
    
    <div v-if="!sent">
      <p>Gik noget galt? Savner du en funktion? Hvad fungerede godt?</p>
      <textarea v-model="msg" placeholder="Jeg synes..." v-focus></textarea>
      <small>Når du sender feedback accepterer du, at vi må kontakte dig per mail med opfølgende spørgsmål, hvis det er relevant.</small>
    </div>
    <div v-else>
      <p>Vi lever og udvikler os ved hjælp af feedback som denne. Vi sætter stor pris på dit bidrag ;)</p>
    </div>

    <template v-slot:footer>
      <AppButton v-if="!sent" @click="give" :disabled="!msg.length" :loading="loading" icon="send" color="primary">Send afsted</AppButton>
      <AppButton v-else @click="close" color="primary">Luk</AppButton>
    </template>
  </Modal>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { store } from '@/store'

export default defineComponent({
  name: 'GiveFeedback',
  setup() {
    const msg = ref('')
    const loading = ref(false)
    const sent = ref(false)

    async function give() {
      if (msg.value) {
        loading.value = true
        await store.user.giveFeedback(msg.value)
        sent.value = true
      }
    }

    function close() {
      store.modal.hideModal('GiveFeedback')
    }

    return { store, give, msg, loading, sent, close }
  }
})
</script>

<style lang="scss" scoped>
textarea {
  width: 100%;
  height: 8rem;
  resize: vertical;
  font-family: inherit;
  font-size: 1rem;
  padding: .5rem;
}
</style>